/**
 * 证书相关API接口
 * 实现证书查询功能
 */

import { req } from '../utils/request'

export class Certificate {
  /**
   * 通过会员信息查询证书
   * @param {Object} params - { name, mobile }
   * @returns {Promise}
   */
  queryByMember(params) {
    return req.post('user.certificate/queryByMember', params)
  }
  
  /**
   * 通过证书编号查询
   * @param {String} certificateNo - 证书编号
   * @returns {Promise}
   */
  queryByCode(certificateNo) {
    return req.get('user.certificate/queryByCode', { certificate_no: certificateNo })
  }

  /**
   * 查询我的证书列表
   * @returns {Promise}
   */
  myList() {
    return req.post('user.certificate/myList')
  }
}

export default new Certificate()
